export default __webpack_public_path__ + "static/media/4.85cfa9c0.jpg";